module.exports = __webpack_public_path__ + "static/media/banner.5bee8d57.png";